(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define("LoadMore", [
            'jquery',
            'request'
        ], factory);
    } else if (typeof module === 'object' && module.exports) {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory(
            require('jquery'),
            require('request')
        );
    } else {
        // Browser globals (root is window)
        root.returnExports = factory(
            root.$,
            root.w5request
        );
    }
}(typeof self !== 'undefined' ? self : this, function ($, w5request) {


    /**
     * Load More Content
     *
     * @param element
     * @param options
     * @constructor
     */
    function LoadMore (element, options) {
        this.element = element;
        this.$element = $(element);

        this.defaults = {
            elementSelector: '.load-more',
            containerSelector: '.more-contents',
            requestOptions: {
                url: 'data: url',
                data: 'data: options',
                method: 'get'
            },
            dataKeys: {
                loadingText: 'loading-text',
                noMoreText: 'nomore-text'
            },
            renderHtml: function () {}
        };

        this.options = $.extend({}, this.defaults, options);

        this.init();
    }

    LoadMore.prototype = {
        init: function () {
            let module = this;

            $(this.options.elementSelector).w5request({
                selector: this.options.elementSelector,
                requestOptions: this.options.requestOptions,
                onEvent: function () {
                    let currentText = $(this).text(),
                        loadingText = $(this).data(module.options.dataKeys.loadingText),
                        self = this;

                    $(this).text(loadingText);

                    $(document).on('AjaxComplete', function () {
                        $(self).text(currentText);

                        $(this).off('AjaxComplete');
                    });
                },
                success: function (response, request) {
                    request.options.requestOptions.data.offset = response.data.offset;

                    let container = document.createDocumentFragment();

                    for ( let i in response.data.items ) {
                        let item = module.getHtml(response.data.items[i]);
                        item.style.opacity = '0';
                        item.style.display = 'none';
                        item.classList.add('hidden');

                        container.appendChild(item);
                    }

                    document.querySelector(module.options.containerSelector).appendChild(container);

                    $(module.options.containerSelector).find('.hidden').slideDown(500);
                    $(module.options.containerSelector).find('.hidden').animate({opacity: 1}, 250, function () {
                        this.classList.remove('hidden');
                    });

                    if ( !response.data.isMore ) {
                        $(this).attr('disabled', 'disabled');
                        $(this).text($(this).data(module.options.dataKeys.noMoreText));
                    }
                }
            });
        },

        getHtml: function (itemData) {
            return this.options.renderHtml(itemData);
        }
    };

    $.fn.loadMore = function (options) {
        $(this).each(function () {
            new LoadMore(this, options);
        });
    }

}));


//////////////////
// WEBPACK FOOTER
// ./js/modules/loadMore/index.js
// module id = 10
// module chunks = 0 1 2 3 4